<template>
  <v-img :src="logo" width="250" height="60" />
</template>

<script setup>
import { useAppStore } from '@/store/store';
import { storeToRefs } from 'pinia';

const { logo } = storeToRefs(useAppStore());
</script>
